import { ContactTiersRead, useSociete, useTiersService } from '@europrocurement/l2d-domain';
import {
    ContactsContactLoginRequestDtoJsonldContactLoginCreate,
    ContactsJsonldContactRead,
} from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { useOrigine } from '@europrocurement/l2d-modules';
import { AxiosResponse } from 'axios';

const useContactKeycloak = () => {
    const origine = useOrigine();
    const xIdSociete = useSociete();
    const { contactsApi } = useTiersService();

    const sendResetPassword = async (
        contact: ContactTiersRead,
    ): Promise<AxiosResponse<ContactsJsonldContactRead>> =>
        await contactsApi.sendResetPasswordEmailContactsItem({
            xIdSociete,
            id: contact?.id?.toString() as string,
        });

    const enableKeycloakAccess = (contact: ContactTiersRead): Promise<string> =>
        new Promise((resolve, reject) => {
            if (!contact?.id) {
                throw new Error('Contact has no ID');
            }

            let mainEmailId = contact.emailsContact.find((email) => email.defaut)?.id;

            if (!mainEmailId) {
                mainEmailId = contact.emailsContact.find(() => true)?.id;
            }

            if (!mainEmailId) {
                throw new Error(
                    "Impossible de créer un accès pour ce contact car il n'a pas d'email",
                );
            }

            const contactPayload: ContactsContactLoginRequestDtoJsonldContactLoginCreate = {
                contact: contact?.id.toString(),
                coordonnee: mainEmailId,
                origine,
            };

            contactsApi
                .createContactLoginContactsCollection({
                    xIdSociete,
                    contactsContactLoginRequestDtoJsonldContactLoginCreate: contactPayload,
                })
                .then((response) => {
                    sendResetPassword(contact)
                        .then(() => resolve(response.data.userIdentifier as string))
                        .catch((e) => reject(e));
                })
                .catch((e) => {
                    reject(e);
                });
        });

    const disableKeycloakAccess = (contact: ContactTiersRead) => {
        if (!contact?.id) {
            throw new Error('Contact has no ID');
        }

        return contactsApi.deleteContactLoginContactsItem({
            xIdSociete,
            id: contact?.id.toString(),
        });
    };

    return { enableKeycloakAccess, sendResetPassword, disableKeycloakAccess };
};

export default useContactKeycloak;
